import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d00a78f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_2 = { class: "production-data" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CProgressBar = _resolveComponent("CProgressBar")!
  const _component_CProgress = _resolveComponent("CProgress")!
  const _component_CSpinner = _resolveComponent("CSpinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createTextVNode(" Produkcja dla "),
    _createElementVNode("span", null, "WEA" + _toDisplayString(_ctx.$route.params.id), 1),
    _hoisted_1,
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      (_ctx.turbine.noErrors)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_CProgress, { class: "mb-3" }, {
              default: _withCtx(() => [
                _createVNode(_component_CProgressBar, {
                  color: "success",
                  variant: "striped",
                  animated: "",
                  value: _ctx.turbine.data.productionBar
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createTextVNode(" Produkcja: " + _toDisplayString(_ctx.turbine.data.productionAvg) + " kW ", 1),
            _hoisted_4,
            _createTextVNode(" Max Produkcja: " + _toDisplayString(_ctx.turbine.data.productionMax) + " kW ", 1),
            _hoisted_5,
            _createTextVNode(" Średnia prędkość wiatru: " + _toDisplayString(_ctx.turbine.data.windSpeedAvg) + " m/s ", 1),
            _hoisted_6,
            _createTextVNode(" Max prędkość wiatru: " + _toDisplayString(_ctx.turbine.data.windSpeedMax) + " m/s ", 1),
            _hoisted_7,
            _createTextVNode(" Produkcja dzisiaj: " + _toDisplayString(_ctx.turbine.totalProduction) + " kWh ", 1)
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.msg), 1))
    ], 512), [
      [_vShow, _ctx.isLoaded]
    ]),
    _withDirectives(_createVNode(_component_CSpinner, {
      color: "success",
      class: "spinner"
    }, null, 512), [
      [_vShow, !_ctx.isLoaded]
    ])
  ], 64))
}